var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-comp"},[_c('el-pagination',{style:({
      width: _vm.pagWidth,
    }),attrs:{"current-page":_vm.currentPage,"page-size":_vm.currentPageSize,"layout":"total, prev, pager, next","total":_vm.total},on:{"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }